if (!customElements.get('slider-component')) {
  customElements.define('slider-component', class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      if (!this.slider || (!this.prevButton && !this.nextButton)) return;
      this.initPages();
      if ('ResizeObserver' in window) new ResizeObserver(() => this.initPages()).observe(this.slider);
      this.slider.addEventListener('scroll', this.update.bind(this), {passive:true});
      if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    initPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(el => el.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      if (!this.sliderItemOffset) this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
      this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset));
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }
    resetPages(){this.initPages()}
    update(){
      if (!this.sliderItemsToShow?.length || !this.sliderItemOffset) return;
      this.currentPage=Math.round(this.slider.scrollLeft/this.sliderItemOffset)+1;
      if(this.currentPageElement)this.currentPageElement.textContent=this.currentPage;
      if(this.pageTotalElement)this.pageTotalElement.textContent=this.totalPages||1;
      if(this.prevButton)this.prevButton.toggleAttribute('disabled',this.slider.scrollLeft<=1);
      const end=this.slider.scrollLeft+this.slider.clientWidth>=this.slider.scrollWidth-2;
      if(this.nextButton)this.nextButton.toggleAttribute('disabled',end);
    }
    isSlideVisible(element,offset=0){if(!element)return false;const end=this.slider.clientWidth+this.slider.scrollLeft-offset;return element.offsetLeft+element.clientWidth<=end&&element.offsetLeft>=this.slider.scrollLeft}
    onButtonClick(event){
      event.preventDefault();
      if(!this.slider)return;
      if(!this.sliderItemOffset)this.initPages();
      if(!this.sliderItemOffset)return;
      const step=parseInt(event.currentTarget.dataset.step||'1',10)||1;
      const dir=event.currentTarget.name==='next'?1:-1;
      this.slider.scrollTo({left:Math.max(0,this.slider.scrollLeft+dir*step*this.sliderItemOffset),behavior:'smooth'});
    }
  });
}
